module.exports = __webpack_public_path__ + "static/img/section-detail.b24e63a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/course-detail/section-detail.png
// module id = WnCU
// module chunks = 1